import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import RequestDemo from '../merchants/RequestDemo';

const MerchantCTA: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <section className="bg-dark py-20 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-300 mb-8">
            Are you a merchant?
          </h2>
          <p className="text-xl text-gray-400 mb-12 max-w-2xl mx-auto">
            Join our network of trusted merchants and provide your customers with instant refunds.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => setIsModalOpen(true)}
              className="bg-primary hover:bg-primary-dark text-white font-medium px-8 py-4 rounded-full transition-colors"
            >
              Request Demo
            </button>
            <Link
              to="/merchant"
              className="bg-dark-light hover:bg-dark-lighter text-white font-medium px-8 py-4 rounded-full transition-colors border border-gray-700"
            >
              Learn More
            </Link>
          </div>
        </div>
      </section>

      <RequestDemo 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default MerchantCTA;